import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "../css/SideNavbar.css";
import axios from "axios";
import SideNavBarAdminMasters from "../sidenavbarcomponents/SideNavBarAdminMasters";
import SideNavBarHoverAdminMasters from "../sidenavbarcomponents/SideNavBarHoverAdminMasters";
import SideNavBarInventory from "../sidenavbarcomponents/SideNavBarInventory";
import SideNavBarHoverInventory from "../sidenavbarcomponents/SideNavBarHoverInventory";
import SideNavBarHR from "../sidenavbarcomponents/SideNavBarHR";
import SideNavBarHoverHR from "../sidenavbarcomponents/SideNavBarHoverHR";
import SideNavBarSales from "../sidenavbarcomponents/SideNavBarSales";
import SideNavBarHoverSales from "../sidenavbarcomponents/SideNavBarHoverSales";
import SideNavBarRateSheet from "../sidenavbarcomponents/SideNavBarRateSheet";
import SideNavBarHoverRateSheet from "../sidenavbarcomponents/SideNavBarHoverRateSheet";
import SideNavBarDraftBooking from "../sidenavbarcomponents/SideNavBarDraftBooking";
import SideNavBarHoverDraftBooking from "../sidenavbarcomponents/SideNavBarHoverDraftBooking";
import SideNavBarShipment from "../sidenavbarcomponents/SideNavBarShipment";
import SideNavBarHoverShipment from "../sidenavbarcomponents/SideNavBarHoverShipment";
import { ToastContainer, toast } from "react-toastify";

function SideNavbar(props) {
    const navigate = useNavigate() 
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");
    const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
    const user_role = sessionStorage['userrole']
    const current_role = sessionStorage['currentRole']
    const [sideNavCollapaseDdl, setSideNavCollapaseDdl] = useState("");

    const getCurrentUserRolePermission = async (roles) => {
        try {
            if(current_role=="All"){
                const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
                const role_permissions_array = []
                for(let i=0; i<response.data.length; i++){
                    for(let j=0; j<response?.data[i]?.permissions_array.length; j++){
                        if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                            role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                        }
                    }
                }

                if(role_permissions_array){
                    setCurrentUserRolePermissionData(role_permissions_array)
                }
            }
            else{
                const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/'+current_role);
                setCurrentUserRolePermissionData(response?.data?.permissions_array)
            }          
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

    useEffect(() => {
        getCurrentUserRolePermission(user_role)
      }, [user_role]);

    useEffect(() => {
        getCurrentUserRolePermission(user_role)
      }, [sessionStorage['currentRole']]);

    useEffect(() => {
        setShowMenu(props.activeMenu)
      }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
      }, [props.activeSubMenu]);

    useEffect(() => {
        console.log("permissionFromTopNavbar", props.permissionFromTopNavbar)
      }, [props.permissionFromTopNavbar]);
      

    return (
        <div class={props.sidebarCollapsed ? "sidenav-expanded mt-5 border" : "sidenav mt-5 border"}>
            {props.sidebarCollapsed ?
                <div className="float-left w-100">
                    <a onClick={() => navigate("/dashboard")} title="Dashboard" className={props.activeMenu == "Dashboard" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}>
                        <i className="fa fa-th-large sidenavbar-icon px-3"></i>
                        <span className="mx-2">Dashboard</span>
                    </a>

                    <SideNavBarInventory 
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarInventory>

                    <SideNavBarHR
                        showMenu={showMenu}
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarHR>

                    <SideNavBarShipment
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarShipment>

                    <SideNavBarAdminMasters 
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarAdminMasters>

                    <SideNavBarSales
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarSales>

                    <SideNavBarRateSheet
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarRateSheet>

                    <SideNavBarDraftBooking
                        showMenu={showMenu} 
                        activeMenu={props.activeMenu}
                        currentUserRolePermissionData={currentUserRolePermissionData}
                        showSubMenu={showSubMenu}
                        activeSubMenuLevel1={props.activeSubMenuLevel1}
                        activeSubMenu={props.activeSubMenu}
                    >
                    </SideNavBarDraftBooking>
                </div>
                :
                <div className="float-left">
                    <a  onClick={() => navigate("/dashboard")} title="Dashboard" className={props.activeMenu == "Dashboard" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}>
                        <i className="fa fa-th-large"></i>
                    </a>

                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Inventory"?"":"Inventory")} 
                        title="Inventory" 
                        className={props.activeMenu == "Inventory" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("inventory:inventory:view")?false:true}>
                        <i className="fa fa-cube"></i>
                    </a>
                    {sideNavCollapaseDdl=="Inventory"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Inventory"?"":"Inventory")}>
                            <SideNavBarHoverInventory 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverInventory>
                        </div>
                        </>
                    :
                        ""
                    }

                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="HR"?"":"HR")}
                        title="HR"
                        className={props.activeMenu == "HR" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("hr:hr:view")?false:true}>
                        <i className="fa fa-users"></i>
                    </a>
                    {sideNavCollapaseDdl=="HR"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="HR"?"":"HR")}>
                            <SideNavBarHoverHR
                                showMenu={showMenu}
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverHR>
                        </div>
                        </>
                    :
                        ""
                    }

                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Shipment"?"":"Shipment")}
                        title="Shipment" 
                        className={props.activeMenu == "Shipment" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("shipment:shipment:view")?false:true}>
                        <i className="fa fa-ship"></i>
                    </a>
                    {sideNavCollapaseDdl=="Shipment"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Shipment"?"":"Shipment")}>
                            <SideNavBarHoverShipment 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverShipment>
                        </div>
                        </>
                    :
                        ""
                    }
                    
                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Master"?"":"Master")} 
                        title="Master" 
                        className={props.activeMenu == "Master" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("master:master:view")?false:true}>
                        <i className="fa fa-database"></i>
                    </a>
                    {sideNavCollapaseDdl=="Master"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Master"?"":"Master")}>
                            <SideNavBarHoverAdminMasters 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverAdminMasters>
                        </div>
                        </>
                    :
                        ""
                    }


                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Sales"?"":"Sales")} 
                        title="Sales" 
                        className={props.activeMenu == "Sales" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("sales:sales:view")?false:true}>
                        <i className="fa fa-clipboard"></i>
                    </a>
                    {sideNavCollapaseDdl=="Sales"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="Sales"?"":"Sales")}>
                            <SideNavBarHoverSales 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverSales>
                        </div>
                        </>
                    :
                        ""
                    }

                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="RateSheet"?"":"RateSheet")} 
                        title="RateSheet" 
                        className={props.activeMenu == "RateSheet" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("ratesheet:ratesheet:view")?false:true}>
                        <i className="fa fa-money"></i>
                    </a>
                    {sideNavCollapaseDdl=="RateSheet"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="RateSheet"?"":"RateSheet")}>
                            <SideNavBarHoverRateSheet 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverRateSheet>
                        </div>
                        </>
                    :
                        ""
                    }


                    <a onMouseEnter={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="DraftBooking"?"":"DraftBooking")} 
                        title="Draft Booking" 
                        className={props.activeMenu == "DraftBooking" ? "sidenav-active pointer sidenavbar-text" : "pointer sidenavbar-text"}
                        hidden={currentUserRolePermissionData?.includes("draftbooking:draftbooking:view")?false:true}>
                        <i className="fa fa-clipboard"></i>
                    </a>
                    {sideNavCollapaseDdl=="DraftBooking"?
                    <>
                        <i className="fa fa-caret-left sidenav-detail-arrow fa-lg"></i>
                        <div className="sidenav-detail" onMouseLeave={() => setSideNavCollapaseDdl(sideNavCollapaseDdl=="DraftBooking"?"":"DraftBooking")}>
                            <SideNavBarHoverDraftBooking 
                                showMenu={showMenu} 
                                activeMenu={props.activeMenu}
                                currentUserRolePermissionData={currentUserRolePermissionData}
                                showSubMenu={showSubMenu}
                                activeSubMenuLevel1={props.activeSubMenuLevel1}
                                activeSubMenu={props.activeSubMenu}
                            >
                            </SideNavBarHoverDraftBooking>
                        </div>
                        </>
                    :
                        ""
                    }
                </div>
            }
        </div>
    );
}

export default SideNavbar;
